import { render, staticRenderFns } from "./AccommodationComparePanel.vue?vue&type=template&id=1ed22048&scoped=true"
import script from "./AccommodationComparePanel.vue?vue&type=script&lang=js"
export * from "./AccommodationComparePanel.vue?vue&type=script&lang=js"
import style0 from "./AccommodationComparePanel.vue?vue&type=style&index=0&id=1ed22048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed22048",
  null
  
)

export default component.exports